import { Maybe } from 'types/global'

export const selectPendoCaller = (callerType: Maybe<string>) => {
  if (callerType?.includes('account')) return 'Account'

  if (callerType?.includes('caller')) return 'Driver'

  if (callerType?.includes('other')) return 'Other'
}
